/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getChecklistModel = /* GraphQL */ `
  query GetChecklistModel($id: ID!) {
    getChecklistModel(id: $id) {
      id
      auditCode
      desc
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listChecklistModels = /* GraphQL */ `
  query ListChecklistModels(
    $filter: ModelChecklistModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklistModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        auditCode
        desc
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAuditTemplate = /* GraphQL */ `
  query GetAuditTemplate($id: ID!) {
    getAuditTemplate(id: $id) {
      id
      name
      desc
      checklists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      owner
      ver
      createdAt
      updatedAt
    }
  }
`;
export const listAuditTemplates = /* GraphQL */ `
  query ListAuditTemplates(
    $filter: ModelAuditTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAuditTemplates(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        name
        desc
        checklists {
          nextToken
        }
        owner
        ver
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getChecklistTemplate = /* GraphQL */ `
  query GetChecklistTemplate($id: ID!) {
    getChecklistTemplate(id: $id) {
      id
      auditCode
      desc
      questions {
        auditCode
        desc
      }
      sublists {
        items {
          id
          auditCode
          desc
          auditTmpl
          parent
          owner
          createdAt
          updatedAt
        }
        nextToken
      }
      auditTmpl
      parent
      owner
      createdAt
      updatedAt
    }
  }
`;
export const listChecklistTemplates = /* GraphQL */ `
  query ListChecklistTemplates(
    $filter: ModelChecklistTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listChecklistTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        questions {
          auditCode
          desc
        }
        sublists {
          nextToken
        }
        auditTmpl
        parent
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getErrorLog = /* GraphQL */ `
  query GetErrorLog($id: ID!) {
    getErrorLog(id: $id) {
      id
      user
      error
      func
      date
      fullPath
      name
      params
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listErrorLogs = /* GraphQL */ `
  query ListErrorLogs(
    $filter: ModelErrorLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listErrorLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        user
        error
        func
        date
        fullPath
        name
        params
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const checklistsByParentList = /* GraphQL */ `
  query ChecklistsByParentList(
    $list: ID
    $auditCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    checklistsByParentList(
      list: $list
      auditCode: $auditCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const checklistsByAudit = /* GraphQL */ `
  query ChecklistsByAudit(
    $audit: ID
    $auditCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    checklistsByAudit(
      audit: $audit
      auditCode: $auditCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const checklistsByAuditTmpl = /* GraphQL */ `
  query ChecklistsByAuditTmpl(
    $auditTmpl: ID
    $auditCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelChecklistTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    checklistsByAuditTmpl(
      auditTmpl: $auditTmpl
      auditCode: $auditCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        questions {
          auditCode
          desc
        }
        sublists {
          nextToken
        }
        auditTmpl
        parent
        owner
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getQuestionModel = /* GraphQL */ `
  query GetQuestionModel($id: ID!) {
    getQuestionModel(id: $id) {
      id
      auditCode
      desc
      result
      notes
      dueDate
      completeDate
      images
      imageData {
        identityId
        imagePath
      }
      response
      reviewers
      list
      audit
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listQuestionModels = /* GraphQL */ `
  query ListQuestionModels(
    $filter: ModelQuestionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listQuestionModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        auditCode
        desc
        result
        notes
        dueDate
        completeDate
        images
        imageData {
          identityId
          imagePath
        }
        response
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const questionsByList = /* GraphQL */ `
  query QuestionsByList(
    $list: ID
    $auditCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    questionsByList(
      list: $list
      auditCode: $auditCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        result
        notes
        dueDate
        completeDate
        images
        imageData {
          identityId
          imagePath
        }
        response
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const questionsByAudit = /* GraphQL */ `
  query QuestionsByAudit(
    $audit: ID
    $auditCode: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelQuestionModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    questionsByAudit(
      audit: $audit
      auditCode: $auditCode
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        auditCode
        desc
        result
        notes
        dueDate
        completeDate
        images
        imageData {
          identityId
          imagePath
        }
        response
        reviewers
        list
        audit
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getAudit = /* GraphQL */ `
  query GetAudit($id: ID!) {
    getAudit(id: $id) {
      id
      state
      reviewState
      facilityName
      date
      mgrName
      dirEmail
      dirPhone
      mgrEmail
      mgrPhone
      checklists {
        auditCode
        desc
        questions {
          auditCode
          desc
          result
          notes
          dueDate
          image
          images
        }
        sublists {
          auditCode
          desc
        }
      }
      owner
      reviewers
      documents {
        identityId
        file
      }
      archived
      deleted
      failedReview
      totalQs
      inReviewDate
      reviewCompleteDate
      completeDate
      createdAt
      updatedAt
    }
  }
`;
export const listAudits = /* GraphQL */ `
  query ListAudits(
    $filter: ModelAuditFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAudits(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        state
        reviewState
        facilityName
        date
        mgrName
        dirEmail
        dirPhone
        mgrEmail
        mgrPhone
        checklists {
          auditCode
          desc
        }
        owner
        reviewers
        documents {
          identityId
          file
        }
        archived
        deleted
        failedReview
        totalQs
        inReviewDate
        reviewCompleteDate
        completeDate
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($owner: String!) {
    getUser(owner: $owner) {
      owner
      email
      createdAt
      updatedAt
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $owner: String
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listUsers(
      owner: $owner
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        owner
        email
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const userByEmail = /* GraphQL */ `
  query UserByEmail(
    $email: String
    $sortDirection: ModelSortDirection
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    userByEmail(
      email: $email
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        owner
        email
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const getReviewGroup = /* GraphQL */ `
  query GetReviewGroup($auditId: ID!, $userEmail: String!) {
    getReviewGroup(auditId: $auditId, userEmail: $userEmail) {
      auditId
      owner
      userEmail
      state
      lastViewed
      completeDate
      addedDate
      role
      createdAt
      updatedAt
    }
  }
`;
export const listReviewGroups = /* GraphQL */ `
  query ListReviewGroups(
    $auditId: ID
    $userEmail: ModelStringKeyConditionInput
    $filter: ModelReviewGroupFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listReviewGroups(
      auditId: $auditId
      userEmail: $userEmail
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        auditId
        owner
        userEmail
        state
        lastViewed
        completeDate
        addedDate
        role
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
export const reviewerByEmail = /* GraphQL */ `
  query ReviewerByEmail(
    $userEmail: String
    $sortDirection: ModelSortDirection
    $filter: ModelReviewGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    reviewerByEmail(
      userEmail: $userEmail
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        auditId
        owner
        userEmail
        state
        lastViewed
        completeDate
        addedDate
        role
        createdAt
        updatedAt
      }
      nextToken
    }
  }
`;
